import { confirmAlert } from "react-confirm-alert";
import { Button } from "tabler-react";

// Function to inject CSS to style the react-confirm-alert container
const injectCustomStyles = () => {
    // Remove any existing styles to avoid duplication
    const existingStyle = document.getElementById("confirm-reminders-styles");
    if (existingStyle) {
        existingStyle.remove();
    }

    // Create style element
    const style = document.createElement("style");
    style.id = "confirm-reminders-styles";
    style.innerHTML = `
    .react-confirm-alert {
      width: 40% !important;
      max-width: 60% !important;
      margin: 0 auto !important;
    }

    .react-confirm-alert > div {
      width: 100% !important;
      max-width: 100% !important;
    }

    .react-confirm-alert-body {
      width: 100% !important;
      max-width: 100% !important;
    }

    .react-confirm-alert-overlay {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }

    .reminders-summary {
      background-color: #f8f9fa;
      border-radius: 3px;
      padding: 15px;
      margin-bottom: 15px;
    }

    .reminders-summary .info-label {
      font-weight: bold;
      margin-right: 5px;
    }

    .reminders-summary .text-danger {
      color: #cd201f;
    }
  `;

    // Add to document head
    document.head.appendChild(style);
};

// Separate component for the dialog content
const RemindersDialog = ({ t, overdueCount, onConfirm, onClose }) => {
    return (
        <div className="custom-ui">
            <h1>{t("finance.invoices.send_reminders")}</h1>

            <div className="reminders-summary">
                <div>
                    <span className="info-label">
                        {t("finance.invoices.overdue_invoices")}:
                    </span>{" "}
                    <span className="text-danger">{overdueCount}</span>
                </div>
                <p className="mt-3">
                    {t("finance.invoices.reminders_count_message", {
                        count: overdueCount,
                    })}
                </p>
            </div>
            <Button className="pull-right" color="secondary" onClick={onClose}>
                {t("general.cancel")}
            </Button>
            <Button
                className="pull-right mr-2"
                color="primary"
                onClick={() => {
                    onConfirm();
                    onClose();
                }}
            >
                {t("general.send")}
            </Button>
        </div>
    );
};

const confirm_reminders = ({ t, overdueCount, onConfirm }) => {
    // Inject custom styles before showing the dialog
    injectCustomStyles();

    confirmAlert({
        customUI: ({ onClose }) => (
            <RemindersDialog
                t={t}
                overdueCount={overdueCount}
                onConfirm={onConfirm}
                onClose={onClose}
            />
        ),
    });
};

export default confirm_reminders;
